__turbopack_context__.v({
  "activeIndicator": "agent-activity-mark-module__nISk9q__activeIndicator",
  "activityCutout": "agent-activity-mark-module__nISk9q__activityCutout",
  "doubtfulEyes": "agent-activity-mark-module__nISk9q__doubtfulEyes",
  "eye": "agent-activity-mark-module__nISk9q__eye",
  "focused-eyes": "agent-activity-mark-module__nISk9q__focused-eyes",
  "gaze": "agent-activity-mark-module__nISk9q__gaze",
  "happy-greeting": "agent-activity-mark-module__nISk9q__happy-greeting",
  "happyEyes": "agent-activity-mark-module__nISk9q__happyEyes",
  "lovingEyes": "agent-activity-mark-module__nISk9q__lovingEyes",
  "mark": "agent-activity-mark-module__nISk9q__mark",
  "stop-appear": "agent-activity-mark-module__nISk9q__stop-appear",
  "surface": "agent-activity-mark-module__nISk9q__surface",
});
